export function requireActions<T>(owner: string, actions: T | null): T {
  if (!actions) throw new Error(`${owner} actions are not set.`);
  return actions;
}
